import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import {
  Alert,
  CircularProgress,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from "@mui/material";
import { usePowerIndexResponse } from "../../lib/hooks";

// import GlobalStyles from '@mui/material/GlobalStyles';

export default function PowerIndex() {
  const [playersCount, setPlayersCount] = React.useState("2");
  const [weight, setWeight] = React.useState({
    p1: "1",
    p2: "2",
    p3: "3",
    p4: "4",
    p5: "5",
    p6: "6",
    p7: "7",
    quota: "2",
  });

  const handleChange = (event: SelectChangeEvent) => {
    setPlayersCount(event.target.value as string);
  };

  const handleChangeWeight = (value: any, index: any) => {
    setWeight({
      ...weight,
      [`p${index + 1}`]: value,
    });
  };

  const { loading, error, powerIndexData } = usePowerIndexResponse({
    quota: weight.quota === "" ? "0" : weight.quota,
    voter_weights: Array.from(Array(parseInt(playersCount)).keys())
      .map((item) =>
        weight[`p${item + 1}` as unknown as `p1`] === ""
          ? 0
          : weight[`p${item + 1}` as unknown as `p1`]
      )
      .join(),
  });

  return (
    <div
      style={{
        display: "flex",
        gap: "20px",
        flexDirection: "column",
        padding: "0px 30px",
        alignItems: "center",
      }}
    >
      <div className="horizontalCenter">
        <FormControl size="small">
          <InputLabel id="demo-simple-select-label">No. of Voters</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={playersCount}
            label="No. of Players"
            onChange={handleChange}
            size="small"
            sx={{ minWidth: "200px" }}
          >
            <MenuItem value={2}>Two</MenuItem>
            <MenuItem value={3}>Three</MenuItem>
            <MenuItem value={4}>Four</MenuItem>
            <MenuItem value={5}>Five</MenuItem>
            <MenuItem value={6}>Six</MenuItem>
            <MenuItem value={7}>Seven</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div
        className="horizontalCenter"
        style={{ gap: "20px", flexWrap: "wrap" }}
      >
        {Array.from(Array(parseInt(playersCount)).keys()).map((item) => (
          <TextField
            variant="outlined"
            size="small"
            label={`V${item + 1} Weight`}
            value={weight[`p${item + 1}` as unknown as `p1`]}
            onChange={(event) => handleChangeWeight(event.target.value, item)}
            inputMode="numeric"
          // value={weight.quota}
          />
        ))}
        <TextField
          variant="outlined"
          size="small"
          label={`Quota`}
          value={weight.quota}
          inputMode="numeric"
          onChange={(event) =>
            setWeight({ ...weight, quota: event.target.value })
          }
        // value={weight.quota}
        />
      </div>
      <>
        {loading && <CircularProgress />}
        {!loading && error !== null && <Alert severity="error">{error}</Alert>}
        {!loading && error === null && (
          <div
            style={{
              display: "flex",
              gap: "20px",
              flexDirection: "column",
              alignItems: "center",
              width:"100%",
            }}
          >
            <Grid container justifyContent="center" spacing={4} sx={{ mt: 1 }}>
              <>
                {playersCount < "4" ? (
                  <>
                    <Grid item lg={8} xs={12}>
                      <TableContainer 
                      component={Paper}
                      sx={{
                        boxShadow:
                          "rgb(100 100 111 / 20%) 0px 7px 19px 0px",
                        borderRadius: "15px",
                      }}>
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Coalition</TableCell>
                              <TableCell align="right">Weight</TableCell>
                              <TableCell align="right">W/L</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {powerIndexData.coalitions.map((row) => (
                              <TableRow
                                key={row.voters.join()}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {row.coalition.map((item: any, index: any) =>
                                    item.is_critical ? (
                                      index !== 0 &&
                                        index !== item.length - 1 ? (
                                        <b>,{item.voter}</b>
                                      ) : (
                                        <b>{item.voter}</b>
                                      )
                                    ) : index !== 0 &&
                                      index !== item.length - 1 ? (
                                      <>,{item.voter}</>
                                    ) : (
                                      item.voter
                                    )
                                  )}
                                </TableCell>
                                <TableCell align="right">
                                  {row.weight}
                                </TableCell>
                                <TableCell align="right">
                                  {row.status}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </>
                ) : playersCount < "6" ? (
                  <>
                    {Array.from(Array(3).keys()).map((i) => {
                      return (
                        <>
                          <Grid item lg={6} xl={4} sm={12} xs={12}>
                            <TableContainer
                              component={Paper}
                              sx={{
                                boxShadow:
                                  "rgb(100 100 111 / 20%) 0px 7px 19px 0px",
                                borderRadius: "15px",
                              }}
                            >
                              <Table aria-label="simple table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Coalition</TableCell>
                                    <TableCell align="right">Weight</TableCell>
                                    <TableCell align="right">W/L</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {powerIndexData.coalitions
                                    .slice(
                                      i *
                                      Math.ceil(
                                        powerIndexData.coalitions.length / 3
                                      ),
                                      (i + 1) *
                                      Math.ceil(
                                        powerIndexData.coalitions.length / 3
                                      )
                                    )
                                    .map((row) => (
                                      <TableRow
                                        key={row.voters.join()}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                        }}
                                      >
                                        <TableCell component="th" scope="row">
                                          {row.coalition.map(
                                            (item: any, index: any) =>
                                              item.is_critical ? (
                                                index !== 0 &&
                                                  index !== item.length - 1 ? (
                                                  <b>,{item.voter}</b>
                                                ) : (
                                                  <b>{item.voter}</b>
                                                )
                                              ) : index !== 0 &&
                                                index !== item.length - 1 ? (
                                                <>,{item.voter}</>
                                              ) : (
                                                item.voter
                                              )
                                          )}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row.weight}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row.status}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {Array.from(Array(7).keys()).map((i) => {
                      return (
                        <>
                          <Grid item lg={6} xl={4} sm={12} xs={12}>
                            <TableContainer component={Paper}
                            sx={{
                              boxShadow:
                                "rgb(100 100 111 / 20%) 0px 7px 19px 0px",
                              borderRadius: "15px",
                            }}
                            >
                              <Table aria-label="simple table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Coalition</TableCell>
                                    <TableCell align="right">Weight</TableCell>
                                    <TableCell align="right">W/L</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {powerIndexData.coalitions
                                    .slice(
                                      i *
                                      Math.floor(
                                        powerIndexData.coalitions.length / 6
                                      ),
                                      (i + 1) *
                                      Math.floor(
                                        powerIndexData.coalitions.length / 6
                                      )
                                    )
                                    .map((row) => (
                                      <TableRow
                                        key={row.voters.join()}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                        }}
                                      >
                                        <TableCell component="th" scope="row">
                                          {row.coalition.map(
                                            (item: any, index: any) =>
                                              item.is_critical ? (
                                                index !== 0 &&
                                                  index !== item.length - 1 ? (
                                                  <b>,{item.voter}</b>
                                                ) : (
                                                  <b>{item.voter}</b>
                                                )
                                              ) : index !== 0 &&
                                                index !== item.length - 1 ? (
                                                <>,{item.voter}</>
                                              ) : (
                                                item.voter
                                              )
                                          )}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row.weight}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row.status}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </>
                      );
                    })}
                  </>
                )}
              </>
            </Grid>

            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Type</TableCell>
                    {Array.from(Array(parseInt(playersCount)).keys()).map(
                      (item) => (
                        <TableCell align="center">P{item + 1}</TableCell>
                      )
                    )}
                    <TableCell align="center">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>Critical Voter Occurance</TableCell>

                    {powerIndexData.power_index.map((row) => (
                      <TableCell align="center">
                        {row.critical_voter_occurrence}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>Voter Power Index</TableCell>

                    {powerIndexData.power_index.map((row) => (
                      <TableCell align="center">
                        {(row.voter_power_index * 100).toFixed(2)}%
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </>
    </div>
  );
}
